import React, { useCallback, useContext, useEffect, useState } from "react";
import { DContext } from "../../context/DataContext";
import { useNavigate } from "react-router-dom";
import Loading from "../blocks/Loading";
import { useTranslation } from "react-i18next";
import { normalizeContact } from "../../utils/contact";
import MetaData from '../../utils/MetaData'

function Booking() {

  const { t } = useTranslation()

  const navPage = useNavigate()
  const [loading, setLoading] = useState(false);
  const [adults, setAdults] = useState(0);
  const [children, setChildren] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [paymentMode, setPaymentMode] = useState('offline')
  const [contactDetails, setContactDetails] = useState({
    fullname: "",
    email: "",
    countryCode: "",
    contact: "",
    city: "",
    country: "",
  });
  const [bookingTitle, setBookingTitle] = useState("")
  const [totalPrice, setTotalPrice] = useState(0)
  const [statusNotice, setStatusNotice] = useState({ type: '', message: '' })
  const [bookingCompleted, setBookingCompleted] = useState(false)
  const { cart, isAuth, currentUser, BeURL, currency, filteredPackages } = useContext(DContext);
  const currencyLabel = currency === 'usd' ? t('packagePage.currency.usd') : t('packagePage.currency.thb')
  const currencySymbol = currency === 'usd' ? '$' : '฿'
  const onlinePaymentMinimum = 20
  const pendingPaymentStorageKey = 'pendingOnlineBooking'
  const successRedirectPath = isAuth ? '/user-bookings' : '/packages'
  const successRedirectLabel = isAuth ? 'orders' : 'packages'
  const canUseOnlinePayment = currency === 'thb' && totalPrice >= onlinePaymentMinimum
  const hasSelectedPackage = Array.isArray(cart) && cart.length > 0

  useEffect(() => {
    if (!hasSelectedPackage && !bookingCompleted) {
      const redirectTimer = setTimeout(() => {
        navPage('/packages')
      }, 2200)

      return () => clearTimeout(redirectTimer)
    }
  }, [hasSelectedPackage, bookingCompleted, navPage])

  useEffect(() => {
    if (cart && cart.length > 0 && currency && filteredPackages) {
      const participantCount = Number(adults || 0) + Number(children || 0)
      let computedTotal = 0

      cart.forEach((cartItem) => {
        const tempPackage = filteredPackages.find(Package => Package.id === cartItem.id)
        if (tempPackage) {
          console.log("tempPackage:::", cartItem)
          if (cartItem.pkg === "price") {
            const tempTotalAmount = (tempPackage.price[currency].adult * adults) + (tempPackage.price[currency].kid * children)
            computedTotal += tempTotalAmount
          }
          else if (cartItem.pkg === "halfPrice") {
            const tempTotalAmount = (tempPackage.halfPrice[currency].adult * adults) + (tempPackage.halfPrice[currency].kid * children)
            computedTotal += tempTotalAmount
          }
          else if (cartItem.pkg === "speedBoat") {
            const tempTotalAmount = (tempPackage.speedBoatPrice[currency].adult * adults) + (tempPackage.speedBoatPrice[currency].kid * children)
            computedTotal += tempTotalAmount
          }
          else if (cartItem.pkg === "longTail") {
            const tempTotalAmount = (tempPackage.longTailPrice[currency].adult * adults) + (tempPackage.longTailPrice[currency].kid * children)
            computedTotal += tempTotalAmount
          }
          else if (!cartItem.pkg) {
            if (tempPackage.priceType === "pkg") {
              const tempTotalAmount = (tempPackage.price[currency].adult * adults) + (tempPackage.price[currency].kid * children)
              computedTotal += tempTotalAmount
            }
            else if (tempPackage.priceType === "boat") {
              const tempTotalAmount = (tempPackage.speedBoatPrice[currency].adult * adults) + (tempPackage.speedBoatPrice[currency].kid * children)
              computedTotal += tempTotalAmount
            }
          }

          if (tempPackage.isEntranceFees) {
            const entranceFeePerHead = Number(tempPackage.entranceFees?.[currency] || 0)
            if (entranceFeePerHead > 0 && participantCount > 0) {
              computedTotal += entranceFeePerHead * participantCount
            }
          }
        }
      })

      setTotalPrice(computedTotal)
    } else {
      setTotalPrice(0)
    }
  }, [cart, currency, adults, children, filteredPackages])

  console.log("carttt:", cart)
  console.log("currency:", currency)
  console.log("bookingTitle:", bookingTitle)

  useEffect(() => {
    if (cart && Array.isArray(cart) && cart.length > 0) {
      cart.forEach((cart, i) => {
        const tempPackage = filteredPackages.find(Package => Package.id === cart.id)
        if (tempPackage) {
          if (i === 0) {
            setBookingTitle(`Payment for the booking: ${tempPackage.title}`)
          }
          else {
            setBookingTitle(prev => `${prev}, ${tempPackage.title}`)
          }
        }
      })
    }
  }, [cart, filteredPackages])

  useEffect(() => {
    if (isAuth && currentUser) {
      const normalizedContact = normalizeContact(currentUser.contact)
      const normalizedCountryCode = normalizedContact.countryCode
        ? (normalizedContact.countryCode.startsWith('+') ? normalizedContact.countryCode : `+${normalizedContact.countryCode.replace(/\D/g, '')}`)
        : ''
      const { fullname, email, city, country } = currentUser
      setContactDetails({ fullname, email, countryCode: normalizedCountryCode, contact: normalizedContact.number, city, country })
    }
  }, [isAuth, currentUser])


  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'contact') {
      const cleaned = value.replace(/\D/g, '');
      setContactDetails({ ...contactDetails, contact: cleaned });
      return;
    }

    if (name === 'countryCode') {
      const cleaned = value.replace(/[^\d+]/g, '');
      setContactDetails({ ...contactDetails, countryCode: cleaned });
      return;
    }

    setContactDetails({ ...contactDetails, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    const sanitizedCountryCode = (contactDetails.countryCode || '').trim();

    if (!adults && !children) newErrors.participants = t("bookingPage.validations.participants");
    if (!startDate) newErrors.startDate = t("bookingPage.validations.startDate");
    if (endDate && new Date(startDate) > new Date(endDate)) newErrors.dateRange = t("bookingPage.validations.startEndDate");
    if (!contactDetails.fullname.trim()) newErrors.fullname = t("bookingPage.validations.fullname");
    if (!contactDetails.email.trim() || !/\S+@\S+\.\S+/.test(contactDetails.email))
      newErrors.email = t("bookingPage.validations.email");
    if (!sanitizedCountryCode || !/^\+\d{1,4}$/.test(sanitizedCountryCode)) newErrors.countryCode = t("bookingPage.validations.countryCode");
    if (!contactDetails.contact || !/^\d{4,15}$/.test(contactDetails.contact))
      newErrors.contact = t("bookingPage.validations.contact");
    if (!contactDetails.city.trim()) newErrors.city = t("bookingPage.validations.city");
    if (!contactDetails.country.trim()) newErrors.country = t("bookingPage.validations.country");
    if (paymentMode === 'online' && currency !== 'thb') newErrors.paymentMode = 'Online payment is only available in THB.';
    if (paymentMode === 'online' && totalPrice < onlinePaymentMinimum) newErrors.amount = `Online payment requires a minimum total of THB ${onlinePaymentMinimum}.`;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const showStatusNotice = (type, message) => {
    setStatusNotice({ type, message })
  }

  const buildBookingDetails = () => {
    const sanitizedCountryCode = String(contactDetails.countryCode || '').trim()
    const normalizedCountryCode = sanitizedCountryCode && !sanitizedCountryCode.startsWith('+')
      ? `+${sanitizedCountryCode.replace(/\D/g, '')}`
      : sanitizedCountryCode

    return {
      adults,
      children,
      startDate,
      endDate: endDate || null,
      fullName: contactDetails.fullname,
      email: contactDetails.email,
      contact: {
        countryCode: normalizedCountryCode,
        number: contactDetails.contact,
      },
      city: contactDetails.city,
      country: contactDetails.country,
      packagesId: cart,
      paymentMode,
      currency
    }
  }

  const confirmBooking = useCallback((bookingDetails) => {
    showStatusNotice('info', 'Finalizing your booking...')
    fetch(`${BeURL}/create-booking`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(bookingDetails),
      credentials: "include"
    })
      .then((res) => res.json())
      .then(data => {
        setLoading(false)
        if (data?.success) {
          const emailStatusText = data?.emailSent === false
            ? ' Booking created, but email notification could not be sent.'
            : ' A booking status email will be sent shortly.'
          setBookingCompleted(true)
          showStatusNotice('success', `${data.message || 'Booking created successfully.'}${emailStatusText} Redirecting to your ${successRedirectLabel} page...`)
          setTimeout(() => {
            window.location.href = successRedirectPath
          }, 2200)
          return
        }

        showStatusNotice('error', data?.message || 'Unable to create booking. Please try again.')
      })
      .catch((err) => {
        setLoading(false)
        console.log("Error in creating booking:", err);
        showStatusNotice('error', 'Trouble in connecting to the Server, Please try again later.')
      });
  }, [BeURL, successRedirectLabel, successRedirectPath])

  useEffect(() => {
    const finalizePendingPayment = async () => {
      if (!BeURL) return

      let pendingPayment = null
      try {
        const raw = sessionStorage.getItem(pendingPaymentStorageKey)
        pendingPayment = raw ? JSON.parse(raw) : null
      } catch (error) {
        console.log('Unable to parse pending payment from storage:', error)
        sessionStorage.removeItem(pendingPaymentStorageKey)
        return
      }

      if (!pendingPayment?.chargeId || !pendingPayment?.bookingDetails) return

      try {
        setLoading(true)
        const response = await fetch(`${BeURL}/charge-status/${pendingPayment.chargeId}`)
        const statusResult = await response.json()

        if (statusResult?.success && statusResult?.status === 'successful') {
          sessionStorage.removeItem(pendingPaymentStorageKey)
          showStatusNotice('success', 'Payment verified successfully. Finalizing your booking...')
          confirmBooking(pendingPayment.bookingDetails)
          return
        }

        if (statusResult?.success && statusResult?.status === 'pending') {
          setLoading(false)
          showStatusNotice('info', 'Your payment is still processing. Please complete the bank authentication and wait a moment.')
          return
        }

        sessionStorage.removeItem(pendingPaymentStorageKey)
        setLoading(false)
        showStatusNotice('error', `Payment was not successful (status: ${statusResult?.status || 'unknown'}). Please try again.`)
      } catch (error) {
        setLoading(false)
        console.log('Error in pending payment verification:', error)
        showStatusNotice('error', 'Unable to verify payment status right now. Please try again.')
      }
    }

    finalizePendingPayment()
  }, [BeURL, confirmBooking, pendingPaymentStorageKey])

  const handleBooking = () => {
    console.log("func called")
    setLoading(true)
    if (validateForm()) {
      if (cart.length === 0) {
        setLoading(false)
        return alert(t("bookingPage.validations.addPackage"));
      }
      else {
        console.log("else block")
        const bookingDetails = buildBookingDetails()

        confirmBooking(bookingDetails)

      }
    }
    else {
      alert(t("bookingPage.validations.fill"));
      setLoading(false)
    }
  };


  // Start of Payment API integration

  const paymentAPIkey = process.env.REACT_APP_OmiseAPI

  // Configure OmiseCard on component mount.
  useEffect(() => {
    if (window.OmiseCard && paymentAPIkey) {
      window.OmiseCard.configure({
        publicKey: paymentAPIkey, // Replace with your actual public key.
      });
    }
  }, [paymentAPIkey]);

  if (!hasSelectedPackage) {
    return (
      <div className='mx-auto flex min-h-[60vh] w-full max-w-3xl items-center justify-center px-4 py-16 text-center'>
        <div className='w-full rounded-3xl border border-slate-200 bg-white p-8 shadow-sm'>
          <p className='text-sm font-semibold uppercase tracking-[0.18em] text-[#1739bd]'>{t('bookingPage.noPackageEyebrow')}</p>
          <h2 className='mt-3 text-2xl font-black text-slate-950 sm:text-3xl'>{t('bookingPage.noPackageTitle')}</h2>
          <p className='mt-4 text-base font-medium text-slate-600'>{t('bookingPage.noPackageSelected')}</p>
          <p className='mt-2 text-sm text-slate-500'>{t('bookingPage.redirecting')}</p>
        </div>
      </div>
    )
  }

  if (bookingCompleted) {
    return (
      <div className='mx-auto flex min-h-[60vh] w-full max-w-3xl items-center justify-center px-4 py-16 text-center'>
        <div className='w-full rounded-3xl border border-emerald-200 bg-emerald-50 p-8 shadow-sm'>
          <p className='text-sm font-semibold uppercase tracking-[0.18em] text-emerald-700'>Booking status</p>
          <h2 className='mt-3 text-2xl font-black text-emerald-900 sm:text-3xl'>Booking completed successfully</h2>
          <p className='mt-4 text-base font-medium text-emerald-800'>Your booking has been recorded. You will be redirected shortly.</p>
          <p className='mt-2 text-sm text-emerald-700'>Redirecting to your {successRedirectLabel} page...</p>
        </div>
      </div>
    )
  }

  // Handle the checkout button click event.
  // const handleCheckout = (event) => {
  //   event.preventDefault(); // Prevent the default form submission.

  //   const form = formRef.current;
  //   if (!window.OmiseCard) {
  //     console.error('OmiseCard is not loaded');
  //     return;
  //   }

  //   // Open the Omise payment modal.
  //   window.OmiseCard.open({
  //     amount: 2000, // The amount in the smallest currency unit.
  //     currency: "THB",
  //     defaultPaymentMethod: "credit_card",
  //     onCreateTokenSuccess: (nonce) => {
  //       // Depending on the returned nonce, set the appropriate hidden field.
  //       if (nonce.startsWith("tokn_")) {
  //         form.elements["omiseToken"].value = nonce;
  //       } else {
  //         form.elements["omiseSource"].value = nonce;
  //       }
  //       // Submit the form.
  //       form.submit();
  //     }
  //   });
  // };

  const handleCheckout = async (event) => {
    event.preventDefault();

    if (!window.OmiseCard) {
      console.error('OmiseCard is not loaded');
      showStatusNotice('error', 'Payment service is unavailable at the moment. Please try again shortly.')
      return;
    }

    if (!validateForm()) {
      showStatusNotice('error', t("bookingPage.validations.fill"));
      return;
    }

    if (cart.length === 0) {
      showStatusNotice('error', t("bookingPage.validations.addPackage"));
      return;
    }

    if (!bookingTitle || bookingTitle === "" || !currency || !totalPrice || totalPrice <= 0) {
      showStatusNotice('error', t("bookingPage.validations.fill"));
      return;
    }

    if (currency !== 'thb') {
      showStatusNotice('error', 'Online payment is only available for THB bookings.');
      return;
    }

    if (totalPrice < onlinePaymentMinimum) {
      showStatusNotice('error', `Online payment requires a minimum total of THB ${onlinePaymentMinimum}.`);
      return;
    }

    const bookingDetails = buildBookingDetails()

    setLoading(true)

    window.OmiseCard.configure({
      publicKey: paymentAPIkey,
      frameLabel: 'Be Alright Krabi',
      submitLabel: 'Pay Now',
      buttonLabel: 'Pay with Omise',
    });

    window.OmiseCard.open({
      amount: Math.round(Number(totalPrice) * 100),
      currency: currency.toUpperCase(),
      defaultPaymentMethod: "credit_card",
      onCreateTokenSuccess: async (nonce) => {
        try {
          const response = await fetch(`${BeURL}/charge`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              omiseToken: nonce.startsWith("tokn_") ? nonce : undefined,
              omiseSource: nonce.startsWith("src_") ? nonce : undefined,
              currency,
              bookingTitle,
              totalPrice,
              returnUri: `${window.location.origin}/booking`,
              customerEmail: contactDetails.email,
              customerName: contactDetails.fullname
            }),
          });

          const result = await response.json();
          if (result.success && result.charge?.status === 'successful') {
            showStatusNotice('success', 'Payment captured successfully. Finalizing your booking...')
            confirmBooking(bookingDetails)
            console.log("Payment Result:", result);
            // Optionally redirect or update UI here
          } else if (result.success && result.requiresAction && result.authorizeUri && result.chargeId) {
            showStatusNotice('info', 'Payment requires bank authentication. Redirecting to your bank now...')
            sessionStorage.setItem(pendingPaymentStorageKey, JSON.stringify({
              chargeId: result.chargeId,
              bookingDetails
            }))
            window.location.href = result.authorizeUri
          } else {
            setLoading(false)
            const gatewayReason = result?.charge?.failure_message || result?.charge?.failure_code || '';
            const details = gatewayReason ? `\nReason: ${gatewayReason}` : '';
            showStatusNotice('error', (result.message || "Payment failed. Please try again.") + details);
          }
        } catch (err) {
          setLoading(false)
          console.error("Charge API Error:", err);
          showStatusNotice('error', 'Something went wrong with payment. Please try again.');
        }
      },
      onFormClosed: () => {
        setLoading(false)
        showStatusNotice('info', 'Payment window closed. You can retry checkout when ready.')
        console.log("Payment form closed");
      },
    });
  };


  // End of Payment API integration



  return (
    <div className='relative'>
      <MetaData
        title={`${t('bookingPage.title')} | Be Alright Krabi`}
        description={t('bookingPage.totalPriceToBePaid')}
        keywords='Be Alright Krabi booking, Krabi tour booking, secure travel booking'
        canonicalUrl={`${window.location.origin}/booking`}
        ogTitle={`${t('bookingPage.title')} | Be Alright Krabi`}
        ogDescription={t('bookingPage.totalPriceToBePaid')}
        ogType='website'
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: t('bookingPage.title'),
          url: `${window.location.origin}/booking`
        }}
        structuredDataId='booking-jsonld'
      />
      <nav className='mb-3' aria-label='breadcrumb'>
        <ol className='flex flex-wrap items-center gap-2 text-sm text-slate-500'>
          <li><a href='/' className='font-medium text-slate-600 transition hover:text-[#1739bd]'>{t("sliderMenu.home")}</a></li>
          <li>/</li>
          <li><a href='/bucket-list' className='font-medium text-slate-600 transition hover:text-[#1739bd]'>{t("sliderMenu.bucketList")}</a></li>
          <li>/</li>
          <li className='font-semibold text-slate-700' aria-current='page'>{t("sliderMenu.booking")}</li>
        </ol>
      </nav>
      <form className='mx-auto w-[94%] max-w-3xl rounded-3xl border border-slate-200 bg-white p-5 shadow-sm'>
        <h2 className='mb-3 text-center text-3xl font-black text-[#1739bd]'>{t("bookingPage.title")}</h2>
        <h3 className='my-3 text-sm font-semibold text-slate-700'>{t("bookingPage.totalPriceToBePaid")}: {currencySymbol} {totalPrice} {currencyLabel}</h3>
        {statusNotice.message && (
          <div className={`mb-3 rounded-xl border px-3 py-2 text-sm font-medium ${statusNotice.type === 'success'
            ? 'border-emerald-300 bg-emerald-50 text-emerald-800'
            : statusNotice.type === 'error'
              ? 'border-rose-300 bg-rose-50 text-rose-800'
              : 'border-sky-300 bg-sky-50 text-sky-800'
            }`}>
            {statusNotice.message}
          </div>
        )}

        <div className='mb-3 grid gap-2 sm:grid-cols-[130px_1fr] sm:items-center'>
          <label className='text-sm font-semibold text-slate-700'>{t("bookingPage.adults")}</label>
          <div className='flex items-center gap-2'>
            <button type='button' className='h-9 w-9 rounded-full border border-[#1739bd] text-lg font-bold text-[#1739bd] transition hover:bg-indigo-50' onClick={() => setAdults(Math.max(0, adults - 1))}>-</button>
            <input type='text' value={adults} readOnly className='w-16 rounded-xl border border-slate-300 py-2 text-center text-sm font-semibold text-slate-800' />
            <button type='button' className='h-9 w-9 rounded-full border border-[#1739bd] text-lg font-bold text-[#1739bd] transition hover:bg-indigo-50' onClick={() => setAdults(adults + 1)}>+</button>
          </div>
        </div>

        <div className='mb-3 grid gap-2 sm:grid-cols-[130px_1fr] sm:items-center'>
          <label className='text-sm font-semibold text-slate-700'>{t("bookingPage.children")}</label>
          <div className='flex items-center gap-2'>
            <button type='button' className='h-9 w-9 rounded-full border border-[#1739bd] text-lg font-bold text-[#1739bd] transition hover:bg-indigo-50' onClick={() => setChildren(Math.max(0, children - 1))}>-</button>
            <input type='text' value={children} readOnly className='w-16 rounded-xl border border-slate-300 py-2 text-center text-sm font-semibold text-slate-800' />
            <button type='button' className='h-9 w-9 rounded-full border border-[#1739bd] text-lg font-bold text-[#1739bd] transition hover:bg-indigo-50' onClick={() => setChildren(children + 1)}>+</button>
          </div>
        </div>
        {errors.participants && <p className='text-sm text-rose-600'>{errors.participants}</p>}

        <div className='mb-3'>
          <label className='mb-1 block text-sm font-semibold text-slate-700'>{t("bookingPage.start")}</label>
          <input type='date' value={startDate} onChange={(e) => setStartDate(e.target.value)} className='w-full rounded-xl border border-slate-300 px-3 py-2 text-sm' />
          {errors.startDate && <p className='mt-1 text-sm text-rose-600'>{errors.startDate}</p>}
        </div>
        <div className='mb-3'>
          <label className='mb-1 block text-sm font-semibold text-slate-700'>{t("bookingPage.end")}</label>
          <input type='date' value={endDate} onChange={(e) => setEndDate(e.target.value)} className='w-full rounded-xl border border-slate-300 px-3 py-2 text-sm' />
          {errors.endDate && <p className='mt-1 text-sm text-rose-600'>{errors.endDate}</p>}
          {errors.dateRange && <p className='mt-1 text-sm text-rose-600'>{errors.dateRange}</p>}
        </div>

        <h5 className='mt-4 text-lg font-bold text-[#1739bd]'>{t("bookingPage.contactTitle")}</h5>
        <div className='mb-3'>
          <label className='mb-1 block text-sm font-semibold text-slate-700'>{t("bookingPage.name")}</label>
          <input type='text' name='fullname' value={contactDetails.fullname} onChange={handleInputChange} className='w-full rounded-xl border border-slate-300 px-3 py-2 text-sm' />
          {errors.fullname && <p className='mt-1 text-sm text-rose-600'>{errors.fullname}</p>}
        </div>
        <div className='mb-3'>
          <label className='mb-1 block text-sm font-semibold text-slate-700'>{t("bookingPage.email")}</label>
          <input type='email' name='email' value={contactDetails.email} onChange={handleInputChange} className='w-full rounded-xl border border-slate-300 px-3 py-2 text-sm' />
          {errors.email && <p className='mt-1 text-sm text-rose-600'>{errors.email}</p>}
        </div>
        <div className='mb-3'>
          <label className='mb-1 block text-sm font-semibold text-slate-700'>{t("bookingPage.contact")}</label>
          <div className='grid grid-cols-3 gap-2'>
            <div className='col-span-1'>
              <input type='text' inputMode='tel' name='countryCode' value={contactDetails.countryCode} onChange={handleInputChange} className='w-full rounded-xl border border-slate-300 px-3 py-2 text-sm' placeholder='+66' />
            </div>
            <div className='col-span-2'>
              <input type='text' inputMode='numeric' pattern='[0-9]*' name='contact' value={contactDetails.contact} onChange={handleInputChange} className='w-full rounded-xl border border-slate-300 px-3 py-2 text-sm' placeholder='817191748' />
            </div>
          </div>
          {errors.countryCode && <p className='mt-1 text-sm text-rose-600'>{errors.countryCode}</p>}
          {errors.contact && <p className='mt-1 text-sm text-rose-600'>{errors.contact}</p>}
        </div>
        <div className='mb-3'>
          <label className='mb-1 block text-sm font-semibold text-slate-700'>{t("bookingPage.city")}</label>
          <input type='text' name='city' value={contactDetails.city} onChange={handleInputChange} className='w-full rounded-xl border border-slate-300 px-3 py-2 text-sm' />
          {errors.city && <p className='mt-1 text-sm text-rose-600'>{errors.city}</p>}
        </div>
        <div className='mb-3'>
          <label className='mb-1 block text-sm font-semibold text-slate-700'>{t("bookingPage.country")}</label>
          <input type='text' name='country' value={contactDetails.country} onChange={handleInputChange} className='w-full rounded-xl border border-slate-300 px-3 py-2 text-sm' />
          {errors.country && <p className='mt-1 text-sm text-rose-600'>{errors.country}</p>}
        </div>

        {cart.length > 0 ? (
          <p className='mt-3 text-sm text-slate-700'>
            {t("bookingPage.selected")} <strong className='font-bold text-[#1739bd]' role='button' onClick={() => navPage(`/bucket-list`)}>{cart.length}</strong> {t("bookingPage.package")}.
          </p>
        ) : (
          <p className='mt-3 text-sm text-slate-700'>
            {t("bookingPage.selected")} <strong>{cart.length}</strong> {t("bookingPage.add")} <a href='/packages' className='font-semibold text-[#1739bd]'>{t("bookingPage.package")}</a> {t("bookingPage.for")}!
          </p>
        )}
        {/* <button
          type="button"
          onClick={handleBooking}
          className=" w-100 sk-btn"
          disabled={cart.length === 0}
        >
          {t("bookingPage.button")}
        </button> */}

        <div className='my-2 flex flex-wrap items-center justify-center gap-4 rounded-xl border border-slate-200 bg-slate-50 p-3'>
          <div className='flex items-center gap-2'>
            <input className='h-4 w-4 rounded border-slate-300 text-[#1739bd] focus:ring-[#1739bd]' type='radio' value='offline' id='offline' checked={paymentMode === "offline"} onChange={(e) => setPaymentMode((e.target.value))} name='paymentMode' />
            <label className='text-sm font-medium text-slate-700' htmlFor='offline'>
              {t("bookingPage.offline")}
            </label>
          </div>

          <div className='flex items-center gap-2'>
            <input className='h-4 w-4 rounded border-slate-300 text-[#1739bd] focus:ring-[#1739bd]' type='radio' value='online' id='online' checked={paymentMode === "online"} onChange={(e) => setPaymentMode((e.target.value))} name='paymentMode' />
            <label className='text-sm font-medium text-slate-700' htmlFor='online'>
              {t("bookingPage.online")}
            </label>
          </div>
        </div>
        {paymentMode === 'online' && currency !== 'thb' && (
          <p className='mb-2 text-sm font-medium text-amber-700'>Online payment is available for THB only.</p>
        )}
        {paymentMode === 'online' && totalPrice < onlinePaymentMinimum && (
          <p className='mb-2 text-sm font-medium text-amber-700'>Online payment requires a minimum total of THB {onlinePaymentMinimum}.</p>
        )}
        {errors.paymentMode && <p className='mb-2 text-sm text-rose-600'>{errors.paymentMode}</p>}
        {errors.amount && <p className='mb-2 text-sm text-rose-600'>{errors.amount}</p>}

        {paymentMode === "offline" && <button type='button' onClick={handleBooking} disabled={cart.length === 0} className='w-full sk-btn'>{t("bookingPage.button")}</button>}
        {paymentMode === "online" && <button
          type="submit"
          id="checkoutButton"
          className='w-full sk-btn'
          disabled={cart.length === 0 || loading || !canUseOnlinePayment}
          onClick={handleCheckout}
        >
          {t("bookingPage.checkout")}
        </button>}
      </form>
      {/* <form
      id="checkoutForm"
      method="POST"
      action={`${BeURL}/charge`}
      ref={formRef}
    >
      <input type="hidden" name="omiseToken" />
      <input type="hidden" name="omiseSource" />

    </form> */}
      {loading && <Loading />}
    </div>
  );
}

export default Booking;
